import { AES, enc } from 'crypto-js';
import { secretPass } from '../constants/SecretConstant'

export const setSessionStorage = (res, data) => {
  // const encrytData=AES.encrypt(JSON.stringify({data}),secretPass).toString();
  // sessionStorage.setItem(res,encrytData)
  let encrytData = AES.encrypt(JSON.stringify(data), secretPass).toString();
  sessionStorage.setItem(res, encrytData)
  //  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
}
export const getSessionStorage = (res) => {
  // const decryptedData = sessionStorage.getItem(res)
  // alert(AES.decrypt(decryptedData, secretPass).toString(enc.Utf8))
  // return AES.decrypt(decryptedData, secretPass).toString(enc.Utf8)
  const decryptedData = sessionStorage?.getItem(res);
  if (decryptedData) {
    return AES.decrypt(decryptedData, secretPass).toString(enc.Utf8);
  } 
  else {
   // console.error("No data found in sessionStorage for key:", res);
    return null; // or handle it according to your application logic
  }
}

export const setLocalStorage = (key, data) => {
  try {
    const encryptedData = AES.encrypt(JSON.stringify(data), secretPass).toString();
    localStorage.setItem(key, encryptedData);
  } catch (error) {
    console.error("Error setting localStorage:", error);
  }
};

export const getLocalStorage = (key) => {
  try {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;

    const decryptedData = AES.decrypt(encryptedData, secretPass).toString(enc.Utf8);
    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (error) {
    console.error("Error getting localStorage:", error);
    return null;
  }
};

export const removeLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing localStorage item:", error);
  }
};
